function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconFacebook = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 28 28"
}, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "icon_facebook_svg__a"
}, /*#__PURE__*/React.createElement("rect", {
  width: 28,
  height: 28,
  "data-name": "Rectangle 1042",
  rx: 14,
  style: {
    fill: "#3a3a3a"
  },
  transform: "translate(108 1037)"
}))), /*#__PURE__*/React.createElement("g", {
  transform: "translate(-108 -1037)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 28,
  height: 28,
  "data-name": "Rectangle 969",
  rx: 14,
  style: {
    fill: "#c4c4c4"
  },
  transform: "translate(108 1037)"
}), /*#__PURE__*/React.createElement("g", {
  "data-name": "Mask Group 87",
  style: {
    clipPath: "url(#icon_facebook_svg__a)"
  }
}, /*#__PURE__*/React.createElement("path", {
  d: "m309.812 208.779.433-2.825h-2.71v-1.833a1.412 1.412 0 0 1 1.592-1.526h1.232v-2.4a15 15 0 0 0-2.187-.191 3.448 3.448 0 0 0-3.691 3.8v2.153H302v2.825h2.481v6.828a9.9 9.9 0 0 0 3.054 0v-6.828z",
  "data-name": "Path 497",
  style: {
    fill: "#fff"
  },
  transform: "translate(-183.903 844.005)"
}))));
export default SvgIconFacebook;